/**
 * Sticky Add to Cart Web Component
 * Shows/hides sticky ATC based on scroll position and buy button visibility
 */

if (!customElements.get("td-sticky-atc")) {
  class TdStickyAtc extends HTMLElement {
  constructor() {
    super();
    this.buyButtonSection = document.querySelector('.product-form__buttons');
    this.mobileThreshold = 800; // Show sticky ATC after specified threshold on mobile
    this.desktopThreshold = 600; // Show sticky ATC after specified threshold on desktop
    this.isVisible = false;
    this.scrollTimeout = null;
  }

    connectedCallback() {
      if (!this.buyButtonSection) return;
      
      this.init();
    }

    init() {
      this.bindEvents();
      this.updateVisibility();
    }

    isMobile() {
      return window.innerWidth <= 750;
    }

    getScrollThreshold() {
      return this.isMobile() ? this.mobileThreshold : this.desktopThreshold;
    }

    bindEvents() {
      // Throttled scroll handler for better performance
      window.addEventListener('scroll', () => {
        if (this.scrollTimeout) {
          clearTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
          this.updateVisibility();
        }, 10);
      });

      // Update visibility when window is resized
      window.addEventListener('resize', () => {
        this.updateVisibility();
      });
    }

    updateVisibility() {
      const scrollY = window.scrollY;
      const buyButtonRect = this.buyButtonSection.getBoundingClientRect();
      const scrollThreshold = this.getScrollThreshold();
      
      // On mobile, only use scroll threshold to avoid flickering
      // On desktop, use both scroll threshold and buy button visibility
      let shouldShow;
      
      if (this.isMobile()) {
        // Mobile: Only show based on scroll threshold
        shouldShow = scrollY > scrollThreshold;
      } else {
        // Desktop: Show if scrolled past threshold OR buy button not visible
        const buyButtonVisible = buyButtonRect.top >= 0 && buyButtonRect.bottom <= window.innerHeight;
        shouldShow = scrollY > scrollThreshold || !buyButtonVisible;
      }
      
      if (shouldShow && !this.isVisible) {
        this.show();
      } else if (!shouldShow && this.isVisible) {
        this.hide();
      }
    }

    show() {
      this.style.display = 'block';
      // Force reflow to ensure the element is rendered before adding the class
      this.offsetHeight;
      this.classList.add('show');
      document.body.classList.add('td-sticky-atc__active');
      this.isVisible = true;
    }

    hide() {
      this.classList.remove('show');
      document.body.classList.remove('td-sticky-atc__active');
      // Hide the element after the transition completes
      setTimeout(() => {
        if (!this.classList.contains('show')) {
          this.style.display = 'none';
        }
      }, 300);
      this.isVisible = false;
    }

    disconnectedCallback() {
      // Clean up scroll timeout when component is removed
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }
    }
  }

  customElements.define("td-sticky-atc", TdStickyAtc);
}
